<template>
  <Modal
    :title="title"
    :openModal="display"
    v-on:close-modal="$emit('close-modal')"
    class="col-6"
  >
    <template v-slot:content>
      <div v-if="account">
        <ErrorAlert v-if="errors.length > 0" :errors="errors" sticky />
        <div class="card">
          <p>
            This account has been sent an onboarding form and their data
            captured under borrowers.
          </p>
        </div>
        <div class="card-footer">
          <Button
            type="submit"
            v-on:button-clicked="handleClick"
            styling="primary"
            text="Complete"
            :disabled="isDisabled"
          ></Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal/Modal.vue';
import Button from '../../components/Button/Button.vue';
import ErrorAlert from '../../components/Alert/ErrorAlert.vue';

export default {
  name: 'CompleteAccount',
  emits: ['close-modal'],
  props: ['account', 'display'],
  components: { Modal, Button, ErrorAlert },
  data() {
    return {
      isLoading: false,
      errors: [],
    };
  },
  computed: {
    isDisabled() {
      return this.isLoading;
    },
    title() {
      return `Completing ${this.account.name}`;
    },
  },
  methods: {
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to complete this account?`,
        button: {
          no: 'Cancel',
          yes: 'Yes',
        },
        callback: (confirm) => {
          if (confirm) {
            this.completeLead();
          }
        },
      });
    },
    completeLead() {
      const { id } = this.account;
      const { comment } = this;
      this.isLoading = true;
      this.$store
        .dispatch(`leads/completeLead`, {
          id,
          comment,
        })
        .then(() => {
          this.isLoading = false;
          this.$emit('close-modal');
        })
        .catch((err) => {
          this.isLoading = false;
          this.errors = err;
        });
    },
  },
};
</script>

<style scoped>
.capitalise {
  text-transform: capitalize;
}
</style>
